const card = document.querySelector('.block-form-broker-popup');

if (card) {
	const cardToggle = card.querySelector('.block-form-broker-popup__toggle');
	const closeToggle = card.querySelector('.block-form-broker-popup__close');
	let autoOpenTimeoutId;

	const animateIntoView = () => {
		card.classList.add('animate-in');
		autoOpenTimeoutId = window.setTimeout(() => {
			setCardState(true);
		}, 3000);
	};

	const clearAutoOpenTimeout = () => {
		if (autoOpenTimeoutId) {
			window.clearTimeout(autoOpenTimeoutId);
			autoOpenTimeoutId = undefined;
		}
	};

	const setCardState = (isOpen) => {
		card.classList.toggle('is-open', isOpen);
		cardToggle?.setAttribute('aria-expanded', String(isOpen));
	};

	const toggleCard = () => {
		clearAutoOpenTimeout();
		setCardState(!card.classList.contains('is-open'));
	};

	const closeCard = () => {
		clearAutoOpenTimeout();
		setCardState(false);
	};

	const handleDocumentClick = (event) => {
		if (!event.target.closest('.block-form-broker-popup')) {
			closeCard();
		}
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', animateIntoView, {
			once: true,
		});
	} else {
		animateIntoView();
	}
	cardToggle?.addEventListener('click', toggleCard);
	closeToggle?.addEventListener('click', closeCard);
	document.addEventListener('click', handleDocumentClick);
}
